export default __webpack_public_path__ + "static/media/test-foto3.95105695.jpg";